module.exports = __webpack_public_path__ + "img/illo_2.eebb85ae.svg";